import Router from '../Router';
import { OffSeasonController } from '../../controllers';
import { Secret } from '../../utils';

const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON);
const offSeasonRoutes = IS_PRE_SEASON ? {
	'off-season-2024': 'offSeasonPage',
	'help/prizes': 'prizes',
	'rankings': 'rankings',
	// 'player-profile(/:player_id)': 'playerProfile',
	// 'stats-centre': 'statsCentre',
	'match-centre/:round_id/:match_id': 'matchCentre',
	'match-centre(/:round_id)': 'matchCentreLanding', '*any': 'redirectToOffSeason'
} : null;

export default class OffSeasonRouter extends Router {
	constructor(args) {
		super(args);

		/**
		 * All routes doesn't required for auth
		 * @type {boolean}
		 */
		this.authOnlyDefault = false;
	}

	initialize(options) {
		this.typeMenu = 'rankings';
		this.controller = new OffSeasonController(options);
	}

	get appRoutes() {
		return {
			...offSeasonRoutes
		};
	}
}